/**
 * Identity admin routes the Settings & staff console calls (§3 roles, §17.1): `GET/POST /v1/admin/staff`,
 * `PATCH /v1/admin/staff/:id`. Shapes come from @windrop/contracts; the update body mirrors the identity module's
 * `UpdateStaffRequest` (name / roles / active, at least one) which contracts do not carry yet.
 */
import type { InviteStaffRequest, PageInfo, StaffRole, StaffUserDto } from '@windrop/contracts';
import { api, type QueryValue } from './client';

export interface StaffListQuery {
  q?: string;
  active?: boolean;
  cursor?: string;
  limit?: number;
}
export interface UpdateStaffRequest {
  name?: string;
  roles?: StaffRole[];
  active?: boolean;
}

const q = (o: object): Record<string, QueryValue> =>
  Object.fromEntries(Object.entries(o).filter(([, v]) => v !== undefined && v !== '')) as Record<
    string,
    QueryValue
  >;

export const staffApi = {
  list: (query: StaffListQuery = {}) =>
    api.get<{ items: StaffUserDto[]; page: PageInfo }>('/v1/admin/staff', q(query)),
  invite: (body: InviteStaffRequest) => api.post<StaffUserDto>('/v1/admin/staff/invite', body),
  update: (staffId: string, body: UpdateStaffRequest) =>
    api.patch<StaffUserDto>(`/v1/admin/staff/${encodeURIComponent(staffId)}`, body),
};
